export const LayoutHeader = ({ children }) => (
  <header>
    <div className="container spaceBetween">{children}</div>
  </header>
);
